// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_attributes.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.app.v1.AppAttributeServiceSearchRequest
 */
export interface AppAttributeServiceSearchRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string query = 2;
     */
    query: string;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: int32 page_size = 4;
     */
    pageSize: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppAttributeServiceSearchResponse
 */
export interface AppAttributeServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppPotentialUserProfileAttribute items = 1;
     */
    items: AppPotentialUserProfileAttribute[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppPotentialUserProfileAttribute
 */
export interface AppPotentialUserProfileAttribute {
    /**
     * @generated from protobuf field: string tenant_id = 1;
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string id = 3;
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: string attribute_name = 7;
     */
    attributeName: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class AppAttributeServiceSearchRequest$Type extends MessageType<AppAttributeServiceSearchRequest> {
    constructor() {
        super("c1.api.app.v1.AppAttributeServiceSearchRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppAttributeServiceSearchRequest
 */
export const AppAttributeServiceSearchRequest = new AppAttributeServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppAttributeServiceSearchResponse$Type extends MessageType<AppAttributeServiceSearchResponse> {
    constructor() {
        super("c1.api.app.v1.AppAttributeServiceSearchResponse", [
            { no: 1, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppPotentialUserProfileAttribute },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppAttributeServiceSearchResponse
 */
export const AppAttributeServiceSearchResponse = new AppAttributeServiceSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppPotentialUserProfileAttribute$Type extends MessageType<AppPotentialUserProfileAttribute> {
    constructor() {
        super("c1.api.app.v1.AppPotentialUserProfileAttribute", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "attribute_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppPotentialUserProfileAttribute
 */
export const AppPotentialUserProfileAttribute = new AppPotentialUserProfileAttribute$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppAttributeSearchService
 */
export const AppAttributeSearchService = new ServiceType("c1.api.app.v1.AppAttributeSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: AppAttributeServiceSearchRequest, O: AppAttributeServiceSearchResponse }
]);
